export const ADD_FACE_TYPE_SUCCESS = 'ADD_FACE_TYPE_SUCCESS';
export const LIST_ALL_FACE_TYPES_SUCCESS = 'LIST_ALL_FACE_TYPES_REQUEST_SUCCESS';
export const UPDATE_FACE_TYPE_SUCCESS = 'UPDATE_FACE_TYPE_SUCCESS';
export const LIST_ALL_FACE_TYPES_REQUEST = 'LIST_ALL_FACE_TYPES_REQUEST';
export const LIST_ALL_FACE_TYPES_FAILURE = 'LIST_ALL_FACE_TYPES_FAILURE';
export const DELETE_FACE_TYPE_SUCCESS = 'DELETE_FACE_TYPE_SUCCESS';
export const CREATE_FACE_TYPE_SUCCESS = 'CREATE_FACE_TYPE_SUCCESS';
